// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const hamburger = "MenuButton__hamburger__Brq-Y";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const icon = "MenuButton__icon__HCi6O";
export const iconCross = "MenuButton__iconCross__gvvv5";
export const iconHamburger = "MenuButton__iconHamburger__WFTnp";
export const medium = "500";
export const numberIcon = "MenuButton__numberIcon__1AEeW";
export const open = "MenuButton__open__syNTy";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";